import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { Pages } from '../Pages'
import { MenuItems } from '../enums/MenuItems'
import Section from '../components/Section'
import LoadingSpinner from '../components/LoadingSpinner'
import roleApi from '../api/role/RoleApi'
import Form from '../components/forms/Form'
import TextInput from '../components/forms/TextInput'
import LayoutSingleView from '../components/layout/LayoutSingleView'

// Define the form schema using Zod
const roleSchema = z.object({
    jobTitle: z.string().min(1, 'Job title is required'),
    searchTerm: z.string().optional(),
})

// Infer TypeScript types from schema
type RoleFormData = z.infer<typeof roleSchema>

function CreateRole(): React.JSX.Element {
    const navigate = useNavigate()
    const [apiError, setApiError] = useState<string | undefined>(undefined)

    // Initialize form with React Hook Form
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm<RoleFormData>({
        resolver: zodResolver(roleSchema),
    })

    // Handle form submission
    const onSubmit = async (data: RoleFormData) => {
        setApiError(undefined) // Reset API error on new submission

        try {
            const roleRes = await roleApi.createRole(data)
            navigate(`${Pages.ManageRole}?id=${roleRes.roleId}`)
        } catch (error) {
            console.error(error)

            if (error instanceof Error) {
                setApiError(error.message)
            } else {
                setApiError(
                    'An unknown error occurred. Please try again later.',
                )
            }
        }
    }

    return (
        <LayoutSingleView activeMenuItem={MenuItems.Roles}>
            <Section title="New Role">
                <LoadingSpinner show={isSubmitting} fullScreen={true} />

                <Form
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    apiError={apiError}
                    entityName="role"
                    cancelTo={Pages.Roles}
                    isSubmitting={isSubmitting}
                >
                    <TextInput
                        id="jobTitle"
                        name="Job Title"
                        placeholder="Job Title..."
                        register={register}
                        errors={errors}
                    />
                    {/* <TextInput
                        id="searchTerm"
                        name="Search Term"
                        placeholder="Java developer with experience in finance..."
                        register={register}
                        errors={errors}
                    /> */}
                </Form>
            </Section>
        </LayoutSingleView>
    )
}

export default CreateRole
